import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

import { apps } from '../../../constants';
import { DatePickerLocale } from '../../../models';
import { CompanyProperty } from '../../../properties';
import { DebugLoggerService } from '../../../services/debug-logger.service';
import { AppStateHolder } from '../../../shared';
import { MoreUsedService } from './more-used.service';


@Component({
  selector: 'crm-more-used',
  templateUrl: 'more-used.component.html',
  standalone: true,
  styleUrls: ['./more-used.component.scss'],
  imports: [TranslateModule]
})

export class MoreUsedComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private service = inject(MoreUsedService);
  private translator = inject(TranslateService);
  private primeConfig = inject(PrimeNGConfig);
  appStateHolder = inject(AppStateHolder);
  private _companyProperty = inject(CompanyProperty);
  private _debugLogger = inject(DebugLoggerService);


  @Input() modify: Boolean;
  @Input() border: boolean;
  @Input() widgetPosition: any;

  requestsSubscribe: Subscription;
  visitedParties: any[];
  openOptions: boolean = false;

  isLoading: boolean = true;

  ngOnInit(): void {
    this._debugLogger.logLifecycle('MoreUsed', 'ngOnInit');
    this.isLoading = true;
    this.translator.setDefaultLang('it');
    this.primeConfig.setTranslation(DatePickerLocale.it);

    if (this.modify) {
      this.isLoading = false;
      this.visitedParties = [];
    } else {
      this.requestsSubscribe = this.service.getMoreVisited().subscribe(result => {
        this._debugLogger.logAction('MoreUsed', 'most visited parties loaded', { count: result?.length });
        this.visitedParties = result
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
      });
    }
  }

  onSelectParty(party) {
    if (party === undefined)
      return;

    let url = this.appStateHolder.getAppUrl(apps.crm);
    this.appStateHolder.setAppNavbarClass(apps.crm);

    if (url.length === 0) {
      let link = ['/console', party.id];
      this.router.navigate(link)
      return;
    }

    let link = ['/app', `${url}/console/${party.id}`];
    this.router.navigate(link);
  }

  hasDatas(): Boolean {
    if (!this.visitedParties) {
      return false;
    }
    return (this.visitedParties.length > 0);
  }

  ngOnDestroy(): void {
    if (this.requestsSubscribe)
      this.requestsSubscribe.unsubscribe();
  }
}


